import { DayPickerProps } from 'react-day-picker';
import 'react-day-picker/style.css';

import StyledCalendar from './Calendar.styles';
import CustomDropdown from './CustomDropdown';

const Calendar = (props: DayPickerProps) => {
  return (
    <StyledCalendar
      animate
      captionLayout='dropdown'
      reverseYears
      navLayout='around'
      components={{
        MonthsDropdown: (dropdownProps) => (
          <CustomDropdown {...dropdownProps} />
        ),
        YearsDropdown: (dropdownProps) => <CustomDropdown {...dropdownProps} />,
      }}
      startMonth={new Date('1970-01-01')}
      {...props}
    />
  );
};

export default Calendar;
